import React from 'react'

import styles from './YouttubeCard.module.css'

const YouttubeCard = ({ profile, name, info1, info2, link, isInsta = false }) => {
    const visitLink = () => {
        window.open(link, "_blank");
    }
    return (
        <div className={styles.main}>
            <div className={styles.profilePic}>
                <img src={profile} alt="" />
            </div>
            <div className={styles.aboutinfo}>
                <span className={styles.name}>{name}</span>
                <span className={styles.info1}>{info1}</span>
                <span className={styles.info2}>{info2}</span>
            </div>
            <div>
                {isInsta ? <button onClick={visitLink} className={styles.follow}>Follow</button> : <button onClick={visitLink} className={styles.subscribe}>Subscribe</button>}
            </div>
        </div>
    )
}

export default YouttubeCard